<template>
    <div id="itsawrap" v-bind:class="{'ismobile': isMobile }">
        <header-component v-model="sidebarOpen"></header-component>
        <sidebar-component v-if="isDesktop" v-model="sidebarOpen"></sidebar-component>
        <router-view></router-view>
        <footer-component></footer-component>
    </div>
</template>
<script>
    import FooterComponent from "./FooterComponent";
    import HeaderComponent from "./HeaderComponent";
    import SidebarComponent from "./SidebarComponent";

    export default {
        name: 'main-layout',
        components: {
            SidebarComponent,
            HeaderComponent, FooterComponent
        },
        data() {
            return {
                sidebarOpen: false
            };
        }
    }
</script>
